import { useWorkerTypesContext } from "@/pages/configurations/workerTypes/context/WorkerTypesContext";
import { cellActionsStyle, rowIconButtonStyle } from "@/utils/ag-grid-defaults";
import { Button } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { find } from "lodash-es";
import { useWorkersContext } from "../../../context/WorkersContext";

type Props = {
	setModalEditDataWorker: Function;
	setModalDeleteWorker: Function;
	setWorkerIdForEdit: Function;
	setWorkerIdForDelete: Function;
};

export const useTableData = ({
	setWorkerIdForEdit,
	setModalEditDataWorker,
	setWorkerIdForDelete,
	setModalDeleteWorker,
}: Props) => {
	const {
		state: { workers },
	} = useWorkersContext();
	const {
		state: { workerTypes },
	} = useWorkerTypesContext();

	const columns: ColDef[] = [
		{
			field: "workerId",
			headerName: "#",
			width: 70,
		},
		{
			field: "workerName",
			headerName: "Name",
			minWidth: 160,
			flex: 2,
		},
		{
			field: "workerTypeId",
			headerName: "Worker Type",
			minWidth: 140,
			flex: 1,
		},
		{
			field: "isActive",
			headerName: "Status",
			minWidth: 110,
			flex: 1,
		},
		{
			colId: "actions",
			headerName: " ",
			sortable: false,
			filter: false,
			resizable: false,
			width: 100,
			maxWidth: 100,
			cellRenderer: (params: ICellRendererParams) => (
				<span style={cellActionsStyle}>
					<Button
						size="small"
						style={rowIconButtonStyle}
						onClick={() => {
							setWorkerIdForEdit(params.data.workerId);
							setModalEditDataWorker(true);
						}}
					>
						<EditIcon style={{ width: 18, height: 18 }} color="primary" />
					</Button>
					<Button
						size="small"
						style={rowIconButtonStyle}
						onClick={() => {
							setWorkerIdForDelete(params.data.workerId);
							setModalDeleteWorker(true);
						}}
					>
						<DeleteIcon style={{ width: 18, height: 18 }} color="secondary" />
					</Button>
				</span>
			),
		},
	];

	const rows = workers.map(
		({ workerId, workerName, workerTypeId, isActive }) => {
			const type = find(workerTypes, ["workerTypeId", workerTypeId]);
			return {
				workerId,
				workerName,
				workerTypeId: type?.workerTypeName,
				isActive: isActive ? "Active" : "Inactive",
			};
		},
	);

	return { rows, columns };
};
